import React from 'react';

import {
  Grid,
  Button,
  Typography,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';

import InputField from '../../common/components/inputField';
import * as asyncSelectData from '../../common/asyncSelectData';

import classes from '../../css/getCSS';


const personalInfoForm = (props) => {
  let buttons = (
    <Button
      variant="contained"
      color="primary"
      type="submit"
      size="large"
      className={classes.Button}
    >
      Update
    </Button>
  );

  if (!props.editMode) {
    buttons = (
      <React.Fragment>
        <Button
          onClick={() => props.redirectToStep(props.prevStep)}
          variant="contained"
          color="primary"
          size="large"
          className={classes.Button}
          style={{ marginRight: '10px' }}
        >
          <PrevIcon />
          Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          size="large"
          className={classes.Button}
        >
          Next
          <NextIcon />
        </Button>
      </React.Fragment>
    );
  }

  let blockquote = null;
  if (!props.editMode) {
    blockquote = (
      <React.Fragment>
        <blockquote className={classes.profileFormQuote}>
          {`Tell us when and where you were born and your height,
            weight and some personal attributes.`}
        </blockquote>
        <br /><br />
      </React.Fragment>
    );
  }

  let extraFieldsClass = null;
  if (props.inputs.marital_status.value.value !== 5
      && props.inputs.marital_status.value.value !== 6) {
    extraFieldsClass = classes.hideFields;
  }

  const extraFields = (
    <div className={extraFieldsClass}>
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="marriage_end_year"
            config={props.inputs.marriage_end_year}
            changed={event => props.inputChangedHandler(event, 'marriage_end_year')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="marriage_years_count"
            config={props.inputs.marriage_years_count}
            changed={event => props.inputChangedHandler(event, 'marriage_years_count')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="children"
            config={props.inputs.children}
            changed={event => props.inputChangedHandler(event, 'children')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="legal"
            config={props.inputs.legal}
            changed={event => props.inputChangedHandler(event, 'legal')}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} /><br />
    </div>
  );

  return (
    <React.Fragment>
      {blockquote}

      <Typography variant="headline" align="center" component="h4" style={{ fontSize: '20px' }}>
        When and Where you were born?
      </Typography>
      <br /><br />
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="birth_date"
            config={props.inputs.birth_date}
            changed={event => props.inputChangedHandler(event, 'birth_date')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="birth_time"
            config={props.inputs.birth_time}
            changed={event => props.inputChangedHandler(event, 'birth_time')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="birth_place"
            config={props.inputs.birth_place}
            changed={event => props.inputChangedHandler(event, 'birth_place')}
            // loadOptions={asyncSelectData.getCityOptions}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} />
      <br />
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="caste"
            config={props.inputs.caste}
            changed={event => props.inputChangedHandler(event, 'caste')}
            loadOptions={asyncSelectData.getCasteOptions}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="marital_status"
            config={props.inputs.marital_status}
            changed={event => props.inputChangedHandler(event, 'marital_status')}
            loadOptions={asyncSelectData.getMaritalStatusOptions}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} />
      <br />
      {extraFields}
      <Grid container spacing={24}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="height"
            config={props.inputs.height}
            changed={event => props.inputChangedHandler(event, 'height')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="weight"
            config={props.inputs.weight}
            changed={event => props.inputChangedHandler(event, 'weight')}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} />
      <br />
      <Grid container spacing={24}>
        <Grid item md={12} xs={12} sm={12}>
          <Typography variant="headline" align="center" component="h4" style={{ fontSize: '20px' }}>
            A little about you in your own words
          </Typography>
          <br />
          <InputField
            id="about"
            config={props.inputs.about}
            changed={event => props.inputChangedHandler(event, 'about')}
          />
        </Grid>
      </Grid>
      <hr className={classes.formHR} />
      <br />
      {buttons}
    </React.Fragment>
  );
};

export default personalInfoForm;



// WEBPACK FOOTER //
// ./src/profile/components/PersonalInfoForm.js